import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

export function getErrorMessage(httpCode: number): string {
  // Add specific error message handling based on error types
  if (httpCode === 401) {
    return 'You are not authorized to perform this action';
  }
  if (httpCode === 403) {
    return 'You do not have permission to access this resource';
  }
  if (httpCode === 404) {
    return 'The requested resource was not found';
  }
  if (httpCode === 500) {
    return 'An internal server error occurred. Please try again later';
  }
  return 'An unexpected error occurred. Please try again';
}

export function handleError(error: HttpErrorResponse): Observable<never> {
  let errorMessage = 'An error occurred';
  if (error.error) {
    errorMessage = error.error.message;
  } else {
    errorMessage = getErrorMessage(error.status);
  }
  return throwError(() => new Error(errorMessage));
}
